export const STORAGE_KEY = '_SM_';
export const PerUserLocalStorageKey = '_U_';
export enum LocalStorageKeys {
	PageContext = '1',
	SpreadSheetColumnSwitcher = '2',
	DetailIndicators = '3',
	CountryCodes = '4',
	DetailPageRecentItems = '5',
	StorageVersionKey = '6',
	CacheManager = '7',
	Dashboard = '8',
	DashboardSettings = '9',
	CustomPage = '10',
}

export const STORAGE_VERSION = 'v.1';
